<script setup>
  import { computed } from 'vue'
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    showText: {
      type: Boolean,
      default: false
    },
    textPosition: {
      type: String,
      default: 'start'
    }
  });

  const buttonClasses = computed(() => ({
    'jwx-close-button': true,
    'jwx-close-button--text-start': props.textPosition === 'start',
    'jwx-close-button--text-end': props.textPosition === 'end' && !props.srOnly,
  }));
</script>

<template>
  <button type="button" :class="buttonClasses">
    <p v-if="showText" class="jwx-close-button__text">
      <slot>
        {{ text }}
      </slot>
    </p>
    <slot name="icon">
      <Icon name="close-x" class="jwx-close-button__icon" />
    </slot>
    <p v-if="!showText" class="sr-only">
      <slot name="sr-text">
        Close
      </slot>
    </p>
  </button>
</template>